export const parsePrice = (priceString: string): number => {
  const parsed = parseFloat(priceString);
  return isNaN(parsed) ? 0 : parsed;
};

export const formatDecimal = (num: number): string => {
  const fixed = num.toFixed(2);

  // Remove trailing zeros and potential decimal point
  return fixed.replace(/\.0+$/, '');
};

export const parseAndFormat = (num?: string): string => {
  if (!num) return '0';
  const parsed = parsePrice(num);
  return formatDecimal(parsed);
};
